module.exports = __webpack_public_path__ + "static/media/francesca-hero-image.9bd3d9d8.png";